import { createSlice } from '@reduxjs/toolkit';

export const navbarSlice = createSlice({
    name: 'navbar',
    initialState: {
      text: '',
      params: '',
    },
    reducers: {
      setText: (state, action) => {
        state.text = action.payload;
      },
      resetText: (state) => {
        state.text = '';
      },
      setNavbarParams: (state, action) => {
        state.params = action.payload;
      },
      resetNavbarParams: (state) => {
        state.params = '';
      },
    }
});

// this is for dispatch
export const { setText, resetText, setNavbarParams, resetNavbarParams } = navbarSlice.actions;

// this is for configureStore
export default navbarSlice.reducer;
